import "flatpickr/dist/themes/material_blue.css";
import "flatpickr/dist/themes/material_green.css";
import Layout from "./CommonComponents/Layout";
import NoPageFound from "./Components/NoPageFound";
import { mainRouteInitial } from "./Data/Constant";
import ProtectedRoute from "./Components/ProtectedRoute";
import Dashboard from "./Pages/Dashboard";
import Login from "./Pages/Login";
import "./App.css";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";

import VidhanSabhaDashboard from "./Pages/VidhanSabhaDashboard";
import ViewMemberList from "./Pages/ViewMemberList";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to={`/${mainRouteInitial}/Login`} replace />,
    },
    {
      path: "/Login",
      element: <Login />,
    },
    {
      path: `/${mainRouteInitial}/Login`,
      element: <Login />,
    },
    {
      path: `/${mainRouteInitial}`,
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="Dashboard" replace />,
        },
        {
          path: "VidhanSabhaDashboard",
          element: <VidhanSabhaDashboard />,
        },

        {
          path: "Dashboard",
          element: <Dashboard />,
        },
        {
          path: "MemberList",
          element: <ViewMemberList />,
        },
        // {
        //   path: "Dashboard/:loginFrom/:userUniqueID",
        //   element: <Dashboard />,
        // },
      ],
    },
    {
      path: "/*",
      element: <NoPageFound />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
